import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials)
      });

      if (response.status === 403) {
        const data = await response.json(); // Parse the response body
        const tempToken = data.tempToken; // Extract the temporary token
        if (tempToken) {
          localStorage.setItem('authToken', tempToken); // Store the temporary token
          navigate('/change-password'); // Redirect to change password page
        } else {
          setError('Password change required, but no token provided.');
        }
        return;
      }

      if (!response.ok) throw new Error('Login failed');

      const { token, user } = await response.json();
      if (token) {
        localStorage.setItem('authToken', token);
        login(token, user);
        navigate('/dashboard');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleRegister = async () => {
    try {
      const response = await fetch('/api/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials)
      });

      if (!response.ok) throw new Error('Registration failed');
      
      const data = await response.json();
      setMessage(data.message || 'Registration successful');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="slate-gray-background" style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
      <div className="login-container" style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
        <img src="/logo.svg" alt="Logo" style={{ width: '150px', height: '150px' }} />
        <h2>Login</h2>
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Email"
            value={credentials.username}
            onChange={(e) => setCredentials({...credentials, username: e.target.value})}
          />
          <input
            type="password"
            placeholder="Password"
            value={credentials.password}
            onChange={(e) => setCredentials({...credentials, password: e.target.value})}
          />
          <button type="submit">Login</button>
          <p style={{ color: 'black' }}>
            Need to change your password?
            <a href="https://discord.com" target="_blank" rel="noopener noreferrer">
            Contact our support on Discord
            </a>.
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;
